import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconClose, IconIndicatorWhite} from "../../Icon";
import {formatDate, getImagePathWithTheme} from "../../utils";
import {Modal, Spin} from "antd";
import {t} from "i18next";
import {LoadingOutlined} from "@ant-design/icons";
import {
    EVENT_FAVIRIATE_CHANGE, EVENT_FORCE_UPDATE,
    EVENT_REFRESH_LIBRARY_LIST,
    EVENT_REFRESH_RECENTS,
    FROM_HISTORY,
    FROM_JOURNAL,
    MAP_MONTH
} from "@/Const";
import {projectHistoryDoc, projectHistoryList, updateNote} from "../../../model";
import {staticProject} from "@/UtilityInner";

let mCallback:any;

const DialogProjectHistory = forwardRef((props, ref) => {
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog,
        onCloseDialog:onCloseDialog
    }))

    const [isShowDialog,setIsShowDialog] = useState(false);
    const [isLoading,setIsLoading] = useState(true);

    const editorRef = useRef(null);
    const [projectData,setProjectData] = useState<any>(null);
    const [arrayHistoryData,setArrayHistoryData] = useState([]);
    const [dialogSize,setDialogSize] = useState({width:'0px',height:'0px',maxHeight:'0px'})
    const [projectInfo,setProjectInfo] = useState<any>(null);

    const idRef = useRef();
    const onShowDialog = (szId:any,callback:any)=>{
        mCallback = callback;
        setIsShowDialog(true);
        idRef.current = szId;

        setArrayHistoryData([]);
        setIsLoading(true);

        projectHistoryList(szId).then(res=>{
            res = res.sort((a,b)=>{
                return b.historyTime - a.historyTime;
            })

            setTimeout(()=>{
                setIsLoading(false);
                setArrayHistoryData(res);
                if (res.length > 0){
                    res[0].isSelected = true;
                    setProjectData(res[0])
                }
            },1000)
        });
    }

    const onCloseDialog = ()=>{
        setIsShowDialog(false);
    }

    useEffect(() => {
        window.addEventListener('resize',eventResize);
        updateDialogSize()


        return () => {
            window.removeEventListener('resize',eventResize);
        }
    },[])

    useEffect(()=>{
        if (projectData){
            projectHistoryDoc(projectData.id).then(async (res)=>{
                const projectInfos = await staticProject({...projectData,doc:res})
                setProjectInfo(projectInfos);
            })
        }
    },[projectData])


    //更新大小
    function eventResize(event:any){
        updateDialogSize()
    }

    const updateDialogSize = ()=>{
        let nWidth = '100vw';
        let nHeight = '100vh';
        let nMaxHeight = '100vh';
        nWidth = (document.body.clientWidth*0.7)+'px';
        nHeight = (document.body.clientHeight*0.7)+'px';
        nMaxHeight = (document.body.clientHeight*0.9)+'px';

        setDialogSize({
            width: nWidth,
            height: nHeight,
            maxHeight:nMaxHeight,
        })
    }

    const getEditorLRPadding = ()=>{
        const nW = document.body.clientWidth;
        return nW/10 + 'px';
    }

    return(
        <Modal centered={true} width={dialogSize.width} bodyStyle={{height: dialogSize.height, margin: '-20px -24px',}}
               open={isShowDialog} closeIcon={<IconClose/>}
               onCancel={() => setIsShowDialog(false)} footer={null}>
            <div className='flex-center' style={{height: '100%',position:'relative'}}>
                {
                    isLoading &&
                    <div className={'flex-row-vertical-center'} style={{
                        position: 'absolute',
                        left: '50%',
                        top: '50%',
                        transform: 'translate(-50%,-50%)',
                    }}>
                        <Spin
                            spinning={true} indicator={<LoadingOutlined style={{fontSize: 26,}} spin/>}/>
                        <span className='ml-12'>{t("Loading")}</span>
                    </div>
                }

                {
                    !isLoading &&
                    <div
                        style={{display: 'grid', gridTemplateColumns: 'auto 1px 260px', width: '100%', height: '100%'}}>
                        <div style={{
                            padding: `0px ${getEditorLRPadding()}`,
                            overflowY: 'auto',
                            marginTop: '46px',
                            marginBottom: '26px'
                        }}>
                            {
                                projectData &&
                                <div className={'flex-column-center'} style={{height:'100%'}}>
                                    <img style={{width:'34px',height:'34px'}} src={getImagePathWithTheme('project_history')}/>
                                    <span className={'mt-6'} style={{fontSize:'18px'}}>{projectData.name || t("Untitled")}</span>
                                    <span className={'mt-4'} style={{color:'var(--project-history-size-color)'}}>{t("Total size")+":"+projectInfo?.formatSize}</span>
                                </div>
                            }
                        </div>

                        <div style={{background: 'var(--line-color)'}}></div>

                        <div style={{marginTop: '22px', paddingBottom:'22px', display: 'flex', flexDirection: 'column',overflow:'hidden'}}>
                            <span className={'font-family-medium ml-16'}
                                  style={{fontSize: '16px', flexShrink: '0'}}>{t("Version history")}</span>
                            <div className={'flex-col'} style={{flexGrow: '1', paddingBottom: '16px',height:'100%',}}>
                                <div className={'flex-col mt-16'} style={{flexGrow: '1',overflow:'auto'}}>
                                    {
                                        arrayHistoryData.map(p => {
                                            return <div className={'flex-col cursor-pointer'} style={{
                                                padding: '6px 12px',
                                                borderRadius: '8px',
                                                minHeight: '62px',
                                                margin: '4px 8px',
                                                justifyContent: 'center',
                                                background: (p.isHover || p.isSelected) ? 'var(--tab-active-background-color)' : 'transparent'
                                            }} onMouseEnter={() => {
                                                var arrayNew = [...arrayHistoryData];
                                                arrayNew.forEach(p => p.isHover = false);
                                                p.isHover = true;
                                                setArrayHistoryData(arrayNew);
                                            }} onMouseLeave={() => {
                                                var arrayNew = [...arrayHistoryData];
                                                arrayNew.forEach(p => p.isHover = false);
                                                setArrayHistoryData(arrayNew);
                                            }} onClick={() => {
                                                var arrayNew = [...arrayHistoryData];
                                                arrayNew.forEach(p => p.isSelected = false);
                                                p.isSelected = true;
                                                setArrayHistoryData(arrayNew);
                                                setProjectData(p);
                                            }}>
                                                <span>{t(MAP_MONTH[`${new Date(p.historyTime).getMonth() + 1}`]) + formatDate(new Date(p.historyTime), ' dd, yyyy hh:mm')}</span>
                                                <span className={'mt-6'}>{p.name}</span>
                                            </div>
                                        })
                                    }
                                </div>
                                <div className={'flex-center'} style={{flexShrink: '0',marginTop:'12px'}}>
                                    <span className={'button-solid-style flex-center'}
                                          style={{width: '164px'}} onClick={()=>{
                                        window.showMessageBox(t("Tips"),t("ConfirmRestore"),t("Cancel"),t("Restore"),null,async ()=>{
                                            const selectItem:any = arrayHistoryData.find(p=>p.isSelected);
                                            setIsShowDialog(false);
                                            if (selectItem){
                                                const newProject = {...selectItem};
                                                newProject.id = newProject.projectId;
                                                delete newProject.projectId;
                                                delete newProject.isHover;
                                                delete newProject.isSelected;

                                                newProject.doc = await projectHistoryDoc(selectItem.id);
                                                updateNote(newProject).then(res=>{
                                                    //刷新。。。。
                                                    postMessage(EVENT_FAVIRIATE_CHANGE);
                                                    postMessage(EVENT_REFRESH_RECENTS);
                                                    if (mCallback){
                                                        mCallback(newProject);
                                                    }
                                                });
                                            }
                                        })
                                    }}>{t("Restore version")}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                }

            </div>


        </Modal>
    )
})

export default DialogProjectHistory;